var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiUpdateProfessionalHotlineRequestMessage, apiUpdateProfessionalHotlineRequestMessageLog, } from '@/actions/ProfessionalHotlineRequestMessageActions';
import { messageFieldName } from '@/components/modules/Chat/ChatForm';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * コンサルホットライン（コンサル側）メッセージ制御用のカスタムフック
 */
export const useHotlineProDetailNegotiateMessage = (options) => {
    const { dispatch, id, onSuccessSubmitLog, onSuccessSubmitMessage, requestId, unmountRef, } = options;
    /**
     * 最後のメッセージ表示時の処理（既読ログ作成）
     */
    const displayLastMessage = useCallback((messageId) => {
        if (!requestId) {
            return;
        }
        // 既読処理を実行
        dispatch(apiUpdateProfessionalHotlineRequestMessageLog({
            path: {
                hotline_request_id: requestId,
                hotline_request_message_id: messageId,
                id,
            },
        }, {}));
        // 送信後の処理（state更新などを行う想定）
        onSuccessSubmitLog === null || onSuccessSubmitLog === void 0 ? void 0 : onSuccessSubmitLog(requestId);
    }, [dispatch, id, onSuccessSubmitLog, requestId]);
    /**
     * チャット 送信処理
     */
    const onSubmitMessage = useCallback((value, form) => __awaiter(void 0, void 0, void 0, function* () {
        if (!requestId) {
            return;
        }
        // メッセージ送信
        yield wrapDispatch(dispatch, apiUpdateProfessionalHotlineRequestMessage({
            json: { message: value.description },
            path: { hotline_request_id: requestId, id },
        }, {}));
        if (unmountRef.current) {
            return;
        }
        // フォームの値を空にする
        form.batch(() => {
            form.change(messageFieldName, '');
            form.resetFieldState(messageFieldName);
        });
        // 送信後の処理（データの引き直しなどを行う想定）
        yield (onSuccessSubmitMessage === null || onSuccessSubmitMessage === void 0 ? void 0 : onSuccessSubmitMessage());
    }), [dispatch, onSuccessSubmitMessage, id, requestId, unmountRef]);
    return {
        displayLastMessage,
        onSubmitMessage,
    };
};
